// extracted by mini-css-extract-plugin
export default {"stars":"cbtzokjz6"};